import http from '@/http'

const PATH = '/contacts'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listContacts (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{contactId: number}} data
     * @returns {Promise<void>}
     */
    async showContact (data) {
        try {
            const response = await http.get(`${PATH}/${data.contactId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async listPropertyHistory ({contactId, params}) {
        try {
            const response = await http.get(`${PATH}/${contactId}/property-history`, {
                params
            })
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async updateProperty ({contactId, data}) {
        try {
            const response = await http.put(`${PATH}/${contactId}/property-history/update`, {...data})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async inviteUser ({ contact }) {
        try {
            const response = await http.post(`${PATH}/${contact.id}/sso/invite-user`, { email_addresses: [contact.email_address] })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async inviteLegacy ({ contact }) {
        try {
            const response = await http.post(`${PATH}/${contact.id}/sso/invite-legacy`, { email_addresses: [contact.email_address] })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async sendInvite ({ contact }) {
        try {
            const response = await http.post(`${PATH}/${contact.id}/sso/send-invite`, { email_address: contact.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async revokeInvite ({ contact }) {
        try {
            const response = await http.put(`${PATH}/${contact.id}/sso/revoke-invite`, { email_address: contact.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async deactivateUser ({ contact }) {
        try {
            const response = await http.put(`${PATH}/${contact.id}/sso/deactivate-user`, { email_address: contact.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async deleteUser ({ contact }) {
        try {
            const response = await http.post(`${PATH}/${contact.id}/sso/delete-user`, { email_address: contact.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async forcePasswordChange ({ contact }) {
        try {
            const response = await http.put(`${PATH}/${contact.id}/sso/force-reset-password`, { email_address: contact.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async sendPasswordReset ({ contact }) {
        try {
            const response = await http.post(`${PATH}/${contact.id}/sso/reset-password`, { email_address: contact.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    async remove2Fa ({ contact }) {
        try {
            const response = await http.delete(`${PATH}/${contact.id}/sso/remove-2fa`, { email_address: contact.email_address })

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
}
